var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n            员工档案信息\n            "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-10px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": function($event) {
        return _vm.Return()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "#FFFFFF",
      "margin": "0px 40px",
      "border": "1px solid #eaebed"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('img', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "src": _vm.from.staff_photo,
      "width": "117px",
      "height": "143px"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "15px"
    },
    attrs: {
      "span": 20
    }
  }, [_c('h3', {
    staticStyle: {
      "font-weight": "600",
      "font-size": "21px",
      "color": "#000000"
    }
  }, [_vm._v(_vm._s(_vm.from.staff_name))]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "300",
      "color": "#556567"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.from.organize_name) + "  " + _vm._s(_vm.from.post_name) + "\n                        ")])])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_edit),
      expression: "!is_edit"
    }],
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "0px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Update
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_edit),
      expression: "is_edit"
    }],
    staticStyle: {
      "height": "40px",
      "margin-top": "0px",
      "margin-right": "10px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_edit),
      expression: "is_edit"
    }],
    staticStyle: {
      "height": "40px",
      "margin-top": "0px",
      "margin-right": "40px",
      "background-color": "#FFFFFF",
      "color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Cancel
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基本信息",
      "name": "basic"
    }
  }, [_c('basic', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_edit),
      expression: "!is_edit"
    }],
    ref: "basic",
    attrs: {
      "from": _vm.from
    }
  }), _vm._v(" "), _c('basicEdit', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_edit),
      expression: "is_edit"
    }],
    ref: "basicEdit",
    attrs: {
      "from": _vm.from
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "工作信息",
      "name": "work"
    }
  }, [_c('work', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_edit),
      expression: "!is_edit"
    }],
    ref: "work",
    attrs: {
      "from": _vm.from
    }
  }), _vm._v(" "), _c('workEdit', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_edit),
      expression: "is_edit"
    }],
    ref: "workEdit",
    attrs: {
      "from": _vm.from
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "保险信息",
      "name": "insurance"
    }
  }, [_c('insurance', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_edit),
      expression: "!is_edit"
    }],
    ref: "insurance",
    attrs: {
      "from": _vm.from
    }
  }), _vm._v(" "), _c('insuranceEdit', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_edit),
      expression: "is_edit"
    }],
    ref: "insuranceEdit",
    attrs: {
      "from": _vm.from
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "附件信息",
      "name": "accessory"
    }
  }, [_c('accessory', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_edit),
      expression: "!is_edit"
    }],
    ref: "accessory",
    attrs: {
      "from": _vm.from
    }
  }), _vm._v(" "), _c('accessoryEdit', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_edit),
      expression: "is_edit"
    }],
    ref: "accessoryEdit",
    attrs: {
      "from": _vm.from
    }
  })], 1)], 1)], 1)], 1)])], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc0989c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/YgdaXx/Ygdaxx_edit.vue
// module id = null
// module chunks = 